module.exports = __webpack_public_path__ + "static/media/sources.ff5f4154.png";